import { Device } from '@twilio/voice-sdk';

const E164_REGEX = /^\+[1-9]\d{7,14}$/;
const CLIENT_REGEX = /^client:[a-zA-Z0-9_-]+$/;

/**
 * @param {string} destination
 * @returns {boolean}
 */
export const isValidDestination = (destination) => {
    const trimmed = (destination || '').trim();
    return E164_REGEX.test(trimmed) || CLIENT_REGEX.test(trimmed);
};

/**
 * @param {string} token  Twilio access token from /twilio/token
 * @returns {Device}
 */
export const createDevice = (token) => {
    return new Device(token, {
        logLevel: 1,
        codecPreferences: ['opus', 'pcmu'],
    });
};

/**
 * @param {Device} device
 * @param {string} to  E.164 number or client:xxx
 * @returns {Promise<import('@twilio/voice-sdk').Call>}
 */
export const startCall = async (device, to) => {
    const call = await device.connect({ params: { To: to } });
    return call;
};

/**
 * @param {import('@twilio/voice-sdk').Call} call
 */
export const disconnectCall = (call) => {
    if (call) call.disconnect();
};
